import { getFunctionalAreas } from "../api/functionalAreas";
import GenericDictionaryPage from "./GenericDictionaryPage";

export default function FunctionalAreas() {
    return (
        <GenericDictionaryPage
            tableKey="functionalAreas"
            fetchData={getFunctionalAreas}
            titleKey="genericDic:functionalAreas"
            newButtonLabel="genericDic:functionalAreasButtonNew"
            hasCode={true}
        />
    );
}
